/** Build deep links for the navigation apps that work on the web. */
export interface NavTarget {
  id: 'google' | 'apple' | 'waze';
  name: string;
  buildUrl: (lat: number, lng: number, label?: string) => string;
}

export const NAV_TARGETS: NavTarget[] = [
  {
    id: 'google',
    name: 'Google Maps',
    buildUrl: (lat, lng, _label) =>
      `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=driving`,
  },
  {
    id: 'apple',
    name: 'Apple Maps',
    buildUrl: (lat, lng, label) =>
      `https://maps.apple.com/?daddr=${lat},${lng}${label ? `&q=${encodeURIComponent(label)}` : ''}&dirflg=d`,
  },
  {
    id: 'waze',
    name: 'Waze',
    buildUrl: (lat, lng) => `https://www.waze.com/ul?ll=${lat},${lng}&navigate=yes`,
  },
];

export function openInApp(target: NavTarget, lat: number, lng: number, label?: string) {
  const url = target.buildUrl(lat, lng, label);
  window.open(url, '_blank', 'noopener,noreferrer');
}
